// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1C5NJ","col":"styles_col__2_1Qm"};